import $ from 'jquery';
import Change from './Change';

const defaults = {
  zoom: 0.5,
  speed: 0.2,
};

export default class Parallax {
  constructor(element, options) {
    this.element = element;
    this.$element = $(this.element);
    this.settings = Object.assign({}, defaults, options);
    this.bounds = {};
    this.register();
    this.update();
  }

  register() {
    Change.onChange(this.update.bind(this));
  }

  update() {
    this.bounds = this.element.getBoundingClientRect();
    // Continue to update component if it's within the viewport.
    if (this.elementIsOnScreen()) {
      const offset = window.pageYOffset * this.settings.speed;
      const props = {
        y: offset * this.settings.speed,
        z: offset * this.settings.zoom,
      };
      // ensure we don't go below a zero setting.
      if (props.y < 0) props.y = 0;
      if (props.z < 0) props.z = 0;
      // Zoom & move asset according to settings in 3d space.
      this.$element.css('transform', `translate3d(0, ${props.y}px, ${props.z}px)`);
    }
  }

  elementIsOnScreen() {
    return window.innerHeight - this.bounds.top >= 0 && this.bounds.bottom >= 0;
  }
}
